<template>
  <div>
    <v-container style="max-width: 1000px">
      <h3 class="headline">{{ $t('Payment Method') }}</h3>

      <v-layout wrap>
        <v-flex xs9>
          <p class="title">
            {{ $t('Bank Transfer') }}
            <template v-if="allowToEdit">
              <input-boolean-no-label
                v-model="contents.allowtransfer"
                @onInputChange="isTransfer = !isTransfer"
              ></input-boolean-no-label>
            </template>
          </p>
        </v-flex>
        <v-flex v-if="allowToEdit" xs3 class="text-xs-right">
          <v-btn
            v-if="!isEditTransfer"
            fab
            outline
            small
            color="primary"
            @click="isEditTransfer = true"
          >
            <em class="fa fa-pencil-alt middle" />
          </v-btn>
        </v-flex>
      </v-layout>
      <transfer-payment :is-edit="isEditTransfer" :init="contents" @onSave="isEditTransfer = false">
        <v-flex xs12 class="pa-1">
          <v-layout row wrap justify-space-between>
            <v-flex xs9 style="align-self: center">
              <h2>
                {{ $t('auto_verify_transfer')
                }}<template v-if="allowToEdit">
                  <label
                    class="toggle-switch small"
                    style="margin-top: 10px; vertical-align: bottom"
                  >
                    <input
                      type="checkbox"
                      :checked="tempActiveVerifySlip"
                      @change="handleUpdateActiveVerifySlip"
                    />
                    <span class="toggle-slider lever round"></span>
                  </label>
                </template>
              </h2>
              <span>{{ $t('auto_verify_transfer_is_enable') }}</span>
            </v-flex>

            <!-- <input-boolean-no-label v-model="tempActiveVerifySlip"></input-boolean-no-label> -->
            <v-flex v-if="allowToEdit" xs3 class="text-xs-right">
              <v-btn fab outline small color="primary" @click="dialogVerify = true">
                <em class="fa fa-pencil-alt middle" />
              </v-btn>
            </v-flex>
          </v-layout>
          <template>
            <div
              v-for="(item, index) in dataVerifySlip"
              :key="index"
              class="form-control intent-item z-border-red pa-3"
            >
              <div
                v-if="(item.status && item.status === 'pending') || item.id.includes('meta')"
                style="text-align: right; color: #fb8c00"
              >
                <small class="mr-2">ยังไม่ได้ยืนยันบัญชีบน META Business Suite</small>
                <i
                  v-tooltip.top="$t('verify_on_meta')"
                  class="fas fa-info-circle"
                  style="font-size: 20px; vertical-align: middle"
                ></i>
              </div>
              <i
                v-if="item.status && item.status === 'verified'"
                v-tooltip.top="$t('Verified by Meta')"
                class="fas fa-check-circle green--text"
                style="float: right; font-size: 20px"
              ></i>
              <template v-if="item.typeAccount && item.typeAccount.value === 'all'">
                <div class="primary--text">
                  {{ $t('bank_name') }} : <span> {{ $t('not_specified_account') }} </span>
                </div>
              </template>
              <template v-else>
                <v-layout wrap>
                  <v-flex xs2>
                    <img
                      v-if="item.bankName && item.bankName === 'promptpay'"
                      style="width: 40px"
                      :src="'/static/img/assets/payment/logo_e_wallet/ewallet.png'"
                    />
                    <img
                      v-else
                      style="width: 40px"
                      :src="
                        getBankName(item.bankName)
                          ? getBankName(item.bankName).image
                          : '/static/img/assets/_global/default-photo.png'
                      "
                    />
                  </v-flex>
                  <v-flex xs10>
                    <div>
                      <div
                        v-if="item.bankName && item.bankName === 'promptpay'"
                        class="primary--text"
                      >
                        {{ $t('promptpay') }}
                      </div>
                      <div v-else class="primary--text">
                        {{ $t('bank_name') }} :
                        <span v-if="getBankName(item.bankName)">{{
                          getBankName(item.bankName).name_th
                        }}</span>
                      </div>
                    </div>
                    <div style="font-size: 90%">
                      <div>
                        <span> {{ $t(paymentTitleType(item)) }} : </span>
                        <span>
                          <template v-if="item.typeAccount.value === 'meta'">xxxxxx</template
                          >{{ item.bankAccountNo }}</span
                        >
                      </div>
                      <div>
                        <span> {{ $t('receiver_name') }} :</span>
                        <span v-if="isMetaVerifySlip"> {{ item.name }} </span>
                        <template v-else>
                          <template v-if="item.keyword && item.keyword.length > 0">
                            <span v-for="(val, index) in item.keyword" :key="`name_text_${index}`">
                              {{ val.text }}
                              <span v-if="index !== item.keyword.length - 1">,</span></span
                            >
                          </template>
                          <span v-else> -</span>
                        </template>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </template>
            </div>
          </template>
        </v-flex>
      </transfer-payment>
    </v-container>

    <v-dialog v-model="dialogVerify" persistent>
      <v-card class="pa-2">
        <intent-prefill-verify-slip
          v-if="dialogVerify"
          :dialog-verify.sync="dialogVerify"
          :isVerify_slip.sync="isVerify_slip"
          :data-verify-slip.sync="dataVerifySlip"
          :can-delete-all="true"
          @onAddPrefill="onAddPrefill"
          @onClickVerifySlip="onClickVerifySlip"
          @clearVerify="clearVerify"
        ></intent-prefill-verify-slip>
      </v-card>
    </v-dialog>

    <template v-if="selectedBot.facebook_ad_account_id">
      <v-divider></v-divider>
      <v-container style="max-width: 1000px">
        <MetaPurchaseSignal primary />
      </v-container>
    </template>

    <v-divider></v-divider>

    <template v-if="selectedBot.pagetype != 'enterprise'">
      <v-container style="max-width: 1000px">
        <fbpay-payment class="my-5"></fbpay-payment>
      </v-container>
      <v-divider></v-divider>
    </template>

    <template
      v-if="
        selectedBot.pagetype != 'enterprise' ||
        $store.state.gbprimetheme.includes(selectedBot.theme) ||
        isActiveGbPrime
      "
    >
      <v-container style="max-width: 1000px">
        <gbprime-payment class="my-5"></gbprime-payment>
      </v-container>
      <v-divider></v-divider>
    </template>

    <v-container style="max-width: 1000px">
      <v-layout wrap>
        <v-flex xs9>
          <h3 class="headline">{{ $t('Profile') }}</h3>
        </v-flex>
        <v-flex xs3 class="text-xs-right">
          <v-btn v-if="!isEditShop" fab outline small color="primary" @click="isEditShop = true">
            <em class="fa fa-pencil-alt middle" />
          </v-btn>
        </v-flex>
      </v-layout>
      <shop-profile
        :is-edit="isEditShop"
        :show-address="true"
        @onSave="isEditShop = false"
      ></shop-profile>
    </v-container>
    <v-divider></v-divider>

    <PaymentMessageAfterSummary />
    <v-divider></v-divider>

    <v-container style="max-width: 1000px"> </v-container>

    <div class="mb-5 mt-5"></div>
  </div>
</template>

<script>
import TransferPayment from '@/components/view/setting/ecommerce/TransferPayment'
import InputBooleanNoLabel from '@/components/view/setting/input-no-label/InputBooleanNoLabel'
import IntentPrefillVerifySlip from '@/components/view/intent/IntentPrefillVerifySlip'

import dayjs from 'dayjs'
import api from '@/api'
import ModalDialog from '@/components/elements/ModalDialog'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import { mapGetters } from 'vuex'

import Multiselect from 'vue-multiselect'
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.min.css'

import ShopProfile from '@/components/view/setting/ecommerce/ShopProfile'
import FbpayPayment from './FbpayPayment'
import GbprimePayment from './GbprimePayment'

import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import PaymentMessageAfterSummary from './PaymentMessageAfterSummary'
import { PAGE } from '@/constants/page.js'
import pageConfigApi from '../../../../api/page-config'
import MetaPurchaseSignal from '@/components/view/billing/MetaPurchaseSignal'

export default {
  components: {
    InputBooleanNoLabel,
    TransferPayment,
    SyncLoader,
    ModalDialog,
    Swatches,
    Multiselect,
    ScaleLoader,
    ShopProfile,
    FbpayPayment,
    GbprimePayment,
    PaymentMessageAfterSummary,
    IntentPrefillVerifySlip,
    MetaPurchaseSignal
  },
  data: function () {
    return {
      tempActiveVerifySlip: false,
      isEditPaymentDetail: false,
      isEditShop: false,
      isEditTransfer: false,
      isEditOrderSummaryMessage: false,
      contents: {},
      isTransfer: false,
      isCreditCard: false,
      paypal: {
        paypal_url: null,
        tracking_id: null,
        loading: true,
        checkTracking: false,
        haveTrackingId: false,

        checkingInterval: null,
        checkingTime: 4,
        checkingTimePerInterval: 5000
      },
      profile: {},
      oldProfile: {},
      showHelpRegisterPaypal: false,
      color: '#1CA085',
      lang: {
        value: 'th',
        flag: 'th',
        label: 'Thai'
      },
      langOptions: [
        {
          value: 'en',
          flag: 'gb',
          label: 'English'
        },
        {
          value: 'th',
          flag: 'th',
          label: 'Thai'
        },
        {
          value: 'la',
          flag: 'la',
          label: 'Laos'
        }
      ],
      wordafter: {
        loading: true,
        wordscartsummary: {
          type: 'text',
          text: ''
        },
        wordsorders: {
          type: 'text',
          text: ''
        }
      },

      isVerify_slip: false,
      dataVerifySlip: [],
      dialogVerify: false
    }
  },
  watch: {
    selectedBot: {
      deep: true,
      immediate: true,
      handler(selectedBot) {
        const vm = this
        vm.tempActiveVerifySlip = selectedBot.verify_slip_is_active
        vm.dataVerifySlip = vm.textVerifySlipToArray(selectedBot.verify_slip_config)
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      paypalTrackingId: 'paypalTrackingId',
      currentLang: 'currentLang'
    }),
    allowToEdit() {
      return (
        this.selectedBot &&
        ((this.$store.state.nestlePages.some((page) => page.pageid == this.selectedBot.pageid) &&
          this.$store.state.userid == 'zwizadmin') ||
          !this.$store.state.nestlePages.some((page) => page.pageid == this.selectedBot.pageid))
      )
    },
    isActiveGbPrime() {
      let statusActive = false
      if (
        ['runkan', 'foodguru', 'cityfresh'].includes(this.selectedBot.theme) ||
        PAGE.TREMENDOUS.includes(this.selectedBot.pageid) ||
        ['Aira'].includes(this.selectedBot.type)
      ) {
        statusActive = true
      }

      return statusActive
    }
  },
  created: function () {
    var vm = this
    vm.paypal.haveTrackingId = vm.paypalTrackingId != null
    vm.$store.dispatch('loadCharges')
    vm.$store.dispatch('loadSetting')

    vm.getSetting()
    vm.getShopProfile()
    if (vm.$store.state.shoptheme.includes(vm.selectedBot.theme)) {
      vm.$store.dispatch('loadCategory').then(function () {
        vm.$store.dispatch('loadProducts')
      })
    }
  },
  mounted: function () {
    ;(function (d, s, id) {
      var js,
        ref = d.getElementsByTagName(s)[0]
      if (!d.getElementById(id)) {
        js = d.createElement(s)
        js.id = id
        js.async = true
        js.src = 'https://www.paypal.com/webapps/merchantboarding/js/lib/lightbox/partner.js'
        ref.parentNode.insertBefore(js, ref)
      }
    })(document, 'script', 'paypal-js')
  },
  methods: {
    textVerifySlipToArray(verifySlipTextConfig) {
      let output = []
      if (verifySlipTextConfig.includes('{verify_slip.bank_info')) {
        try {
          this.isVerify_slip = true
          const textSplitValue = verifySlipTextConfig.split('{verify_slip.bank_info=')
          const textSplitValue2 = textSplitValue[1].split(',')
          const textValue = textSplitValue2[0].split('^')
          textValue[textValue.length - 1] = textValue[textValue.length - 1].split('}')[0]
          textValue.map((item, index) => {
            let typeAccount = null
            if (item.split('|')[0] === 'promptpay') {
              typeAccount = { value: 'promptpay', label: 'Promptpay' }
            } else if (item.split('|')[0].includes('ew')) {
              typeAccount = { value: 'eWallet', label: 'E-Wallet' }
            } else if (item.split('|')[0].includes('pg') || item.split('|')[0] === 'pgother') {
              typeAccount = { value: 'paymentGateway', label: 'Payment Gateway' }
            } else {
              typeAccount = { value: 'transfer', label: 'Transfer' }
            }

            let keyword = []
            if (item.split('|') && item.split('|')[2]) {
              item
                .split('|')[2]
                .split('!')
                .forEach((element) => {
                  keyword.push({ text: element })
                })
            }
            output.push({
              id: `${dayjs().format('x')}_${index}`,
              typeAccount: typeAccount,
              bankAccountNo: item.split('|')[1],
              bankName: item.split('|')[0],
              keyword: keyword
            })
          })
        } catch (error) {
          console.error(error)
        }
      }
      return output
    },
    async handleUpdateActiveVerifySlip() {
      try {
        const updateTo = !this.tempActiveVerifySlip
        this.tempActiveVerifySlip = updateTo
        await this.handleUpdateVerifySlip({ verify_slip_is_active: updateTo })
        this.$store.dispatch('selectBot', { ...this.selectedBot, verify_slip_is_active: updateTo })
      } catch (error) {
        console.error(error)
        this.swal.fire({ type: 'error', text: 'อัพเดทข้อมูลไม่สำเร็จ' })
        this.tempActiveVerifySlip = this.selectedBot.verify_slip_is_active
      }
    },
    handleUpdateVerifySlip(updateData) {
      const body = {
        page_id: this.selectedBot.pageid,
        ...updateData
      }
      return pageConfigApi.postUpdatePageConfig(body)
    },
    paymentTitleType(item) {
      if (item.bankName && item.bankName === 'transfer') {
        return 'bank_account'
      } else if (item.bankName && item.bankName === 'promptpay') {
        return 'promptpay_code'
      } else if (item.typeAccount && item.typeAccount.value === 'eWallet') {
        return 'E-Wallet ID'
      } else if (item.typeAccount && item.typeAccount.value === 'paymentGateway') {
        return 'Biller ID'
      } else {
        return 'bank_account_no'
      }
    },
    getBankName(bankName) {
      const vm = this
      let bankAlltype = vm.$store.state.bankForVerify.concat(vm.$store.state.eWalletForVerify)
      bankAlltype = bankAlltype.concat(vm.$store.state.paymentGateway)
      return bankAlltype.filter((bankInfo) => bankInfo.value === bankName)[0]
    },
    onClickVerifySlip() {
      const vm = this
      vm.$emit('onClickVerifySlip')
      vm.isVerify_slip = true
    },
    async clearVerify() {
      const vm = this
      vm.dataVerifySlip = []
      vm.normal = []
      vm.isVerify_slip = false
      vm.$emit('onClickClearVerifySlip')
    },
    onAddPrefill: function (payload) {
      const vm = this
      if (payload == '{verify_slip.image}') {
        vm.dataVerifySlip = []
        try {
          this.handleUpdateVerifySlip({ verify_slip_config: '' })
        } catch (error) {
          this.swal.fire({ type: 'error', text: 'อัพเดทข้อมูลไม่สำเร็จ' })
          console.error('handleUpdateVerifySlip : ', error)
        }
        return
      } else {
        try {
          console.log('qqq', payload)
          this.handleUpdateVerifySlip({ verify_slip_config: payload })
        } catch (error) {
          this.swal.fire({ type: 'error', text: 'อัพเดทข้อมูลไม่สำเร็จ' })
          console.error('handleUpdateVerifySlip : ', error)
        }
      }

      if (vm.isVerify_slip) {
        vm.normal = []
        vm.keyword = []
        vm.exactly = []
        vm.startwith = []
        vm.endwith = []
        vm.startandendwith = []
        vm.normal = [{ text: payload }]
      } else {
        vm.normal.push({ text: payload })
      }
      vm.dataVerifySlip = []
      if (vm.normal.length > 0 && vm.normal[0].text.includes('{verify_slip.bank_info')) {
        vm.dataVerifySlip = vm.textVerifySlipToArray(vm.normal[0].text)
      }
    },
    addWordOrderPrefill: function (prefill) {
      var vm = this
      let cursorPosition = vm.$refs.answer_word_orders.$el.selectionStart
      vm.wordafter.wordsorders.text = [
        vm.wordafter.wordsorders.text.slice(0, cursorPosition),
        '{' + prefill + '}',
        vm.wordafter.wordsorders.text.slice(cursorPosition)
      ].join('')
    },
    onSelectLang: function (val) {
      this.lang = val
      this.profile.shoplang = val.value
    },
    getSetting: function () {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }

      api.getSetting(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.contents = {}
        if (response.data) {
          response.data.map(function (setting, index) {
            vm.contents[setting.contenttype] = setting
            if (setting.contenttype === 'allowtransfer') {
              vm.isTransfer = setting.contentvalue
            }
            if (setting.contenttype === 'allowcreditcard') {
              vm.isCreditCard = setting.contentvalue
            }
          })
        }
      })
    },
    getShopProfile: function () {
      let data = {
        pageid: this.selectedBot.pageid
      }
      let vm = this
      api.getShopProfile(data, function (error, response) {
        if (error) {
          console.error(error)

          return
        }
        if (response.shopprofile) {
          vm.profile = {
            pageaddress: response.shopprofile.pageaddress,
            description: response.shopprofile.description,
            pageshortlink: response.shopprofile.pageshortlink,
            pagename: response.shopprofile.pagename,
            shoplang: response.shopprofile.shoplang,
            shopcolor: response.shopprofile.shopcolor
          }
          vm.oldProfile = {
            pageaddress: response.shopprofile.pageaddress,
            description: response.shopprofile.description,
            pageshortlink: response.shopprofile.pageshortlink,
            pagename: response.shopprofile.pagename,
            shoplang: response.shopprofile.shoplang,
            shopcolor: response.shopprofile.shopcolor
          }
          var findLang = vm.langOptions.find(function (el) {
            return el.value == response.shopprofile.shoplang
          })

          if (findLang) {
            vm.lang = findLang
          } else {
            vm.lang = vm.langOptions[1]
          }

          vm.color = response.shopprofile.shopcolor ? response.shopprofile.shopcolor : '#1CA085'
        }
      })
    },
    saveProfile: function () {
      let vm = this
      let data = {
        description: vm.profile.description != null ? vm.profile.description : '',
        pageaddress: vm.profile.pageaddress != null ? vm.profile.pageaddress : '',
        pageid: vm.selectedBot.pageid,
        pageshortlink: vm.profile.pageshortlink != null ? vm.profile.pageshortlink : vm.pageid
      }
      if (vm.$store.getters.getPackage == 'premium') {
        data.shoplang = vm.profile.shoplang
        data.shopcolor = vm.color
      }

      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        api.editShopProfile(data, function (error, response) {
          if (error) {
            console.error(error)
            return
          }
          vm.isEditShop = false
          vm.oldProfile.description = vm.profile.description
          vm.oldProfile.pageaddress = vm.profile.pageaddress
          vm.oldProfile.pageshortlink = vm.profile.pageshortlink
        })
      })
    },

    resetPageShortLink: function () {
      if (!this.selectedBot.pageid || this.selectedBot.pageid == null) {
        return false
      }
      this.isChangeShortlink = true
      this.profile.pageshortlink = this.selectedBot.pageid
    },
    cancelEditProfile: function () {
      var vm = this
      this.profile.description = this.oldProfile.description
      this.profile.pageaddress = this.oldProfile.pageaddress
      this.profile.pageshortlink = this.oldProfile.pageshortlink
      var findLang = vm.langOptions.find(function (el) {
        return el.value == vm.oldProfile.shoplang
      })

      if (findLang) {
        vm.lang = findLang
      } else {
        vm.lang = vm.langOptions[1]
      }
      this.isEditShop = false
    },
    onRefreshTrackingStatus: function () {
      var vm = this
      vm.paypal.checkingTime = 6
      vm.paypal.checkTracking = true

      vm.checkingTrackingStatus(function (status) {
        if (status) {
          clearInterval(vm.paypal.checkingInterval)
          vm.paypal.checkTracking = false
        } else {
          vm.paypal.checkingInterval = setInterval(() => {
            vm.checkingTrackingStatus(function (status) {
              if (vm.paypal.checkingTime === 0 || status) {
                clearInterval(vm.paypal.checkingInterval)
                vm.paypal.checkTracking = false
              }
              vm.paypal.checkingTime--
            })
          }, vm.paypal.checkingTimePerInterval)
        }
      })
    },
    checkingTrackingStatus: function (callback) {
      var vm = this
      var data = {
        tracking_id: vm.paypalTrackingId
      }
      api.getPaypalTrackingStatus(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }

        if (response.status === 'pending') {
          callback(false)
        } else if (
          response.status === 'success' &&
          response.merchant_id !== '' &&
          response.merchant_id != null
        ) {
          data = {
            pageid: vm.selectedBot.pageid,
            paypal_merchantid: response.merchant_id
          }
          api.updatePaypalMerchantId(data, function (error, response) {
            if (error) {
              console.error(error)
              return
            }
            vm.contents.allowcreditcard.contentvalue = true

            vm.$store.dispatch('updateMerchantId', data.paypal_merchantid)

            callback(true)
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 600px) {
  .border-right {
    border-right: 1px solid #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Payment.vue